/**
 * useSelectedHolder — Advertising Optimization wrapper over the
 * platform-level `useHolderSwitcher`. Selection is shared with every
 * other arche so switching workspace anywhere is reflected here.
 */

import { useHolderSwitcher } from '@/components/HolderSwitcher';

export function useSelectedHolder(): {
  holderId: string | null;
  setHolderId: (next: string | null) => void;
  isLoading: boolean;
} {
  const switcher = useHolderSwitcher();
  return {
    holderId: switcher.selectedHolderId,
    setHolderId: switcher.setSelectedHolderId,
    isLoading: switcher.isLoading,
  };
}
